export const LANGUAGES = {
  PT: {
    languageId: 1,
    name: 'Portuguese',
    abrev: 'pt',
    fullLocale: 'pt_PT',
    order: 1
  },
  EN: {
    languageId: 2,
    name: 'English',
    abrev: 'en',
    fullLocale: 'en_GB',
    order: 2
  },
  FR: {
    languageId: 3,
    name: 'French',
    abrev: 'fr',
    fullLocale: 'fr_FR',
    order: 3
  },
  DE: {
    languageId: 4,
    name: 'German',
    abrev: 'de',
    fullLocale: 'de_DE',
    order: 4
  },
  ES: {
    languageId: 5,
    name: 'Spanish',
    abrev: 'es',
    fullLocale: 'es_ES',
    order: 5
  },
  NL: {
    languageId: 6,
    name: 'Dutch',
    abrev: 'nl',
    fullLocale: 'nl_BE',
    order: 6
  }
}
